import React, { useState } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { ConvertPriceToString, datePlus7DaysYYYYMMDDHHmmss, dateToYYYYMMDD, dateToYYYYMMDDHHMMSS } from '../../../Helpers/CustomConverter';
import LoadingSpinner from '../../Components/LoadingSpinner';
import PaymentWithValueModal from "../../Components/Modals/PaymentWithValueModal.jsx";
import { usePayment } from "../../../Providers/PaymentProvider";
import { useAuth } from '../../../Providers/AuthProvider';
import usePaymentFlow from '../../../Hooks/usePaymentFlow';



const CreditLimitCard = ({ isLoading, creditLimit }) => {
    const [limit, setLimit] = useState(0.0)
    const [isChangeLimitVisible, setIsChangeLimitVisible] = useState(false);
    const [showMessageAskToPay, setShowMessageAskToPay] = useState(false);
    const { activePaymentSuppliersForSites } = usePayment();
    const isElavonActive = activePaymentSuppliersForSites.some(s => s.supplierName === 'Elavon')
    const { authState } = useAuth();
    const { createPaymentAndRedirect } = usePaymentFlow();

    const handleEditLimit = (e) => {
        const { value } = e.target.value;
        setLimit(value)
    }

    const handleAskToPayModal = async (amountToPay) => {
        setShowMessageAskToPay(false)
        if (amountToPay) {
            await createPaymentAndRedirect({
                orderId: authState.custId + '-' + dateToYYYYMMDDHHMMSS(),
                docOrderId: authState.custId + '-' + dateToYYYYMMDDHHMMSS(),
                docOrderDate: dateToYYYYMMDD(),
                siteId: authState.siteId,
                userId: authState.user.userId,
                custId: authState.custId,
                amount: amountToPay,
                customerEmail: authState.user.email,
                paymentTitle: `Spłata limitu kredytowego`,
                gateWayId: -1,
                paymentExpDate: datePlus7DaysYYYYMMDDHHmmss()
            })
        }
    }

    const handleCancelButtonClick = () => {
        setLimit(0.0)
        setIsChangeLimitVisible(false);
    }

    const handleChangeLimitButtonClick = () => {
        setIsChangeLimitVisible(true);
    }

    const handleChangeLimit = () => {
        setLimit(0.0)
        setIsChangeLimitVisible(false);
    }

    return (
        <div>
            <div className='row justify-content-center'>
                <div className='justify-content-center mt-2'>
                    <div>
                        <Modal size='md' show={isChangeLimitVisible} onHide={handleCancelButtonClick} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Zmień limit</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <ChangeCreditLimit handleEditLimit={handleEditLimit} handleChangeLimit={handleChangeLimit} />
                            </Modal.Body>
                        </Modal>
                        <div className='panel-header-title'>Limit kredytowy</div>
                        {isLoading && <LoadingSpinner />}
                        {!isLoading && <div className='row'>
                            <div className='col-auto ms-1'>Dostępny limit:<br />  <span style={{ fontWeight: 'bold', fontSize: '25px' }}>{ConvertPriceToString(creditLimit.remainCredit)}</span></div>
                            <div className='col-auto ms-1'>Całkowity limit:<br /> <span style={{ fontWeight: 'bold', fontSize: '25px' }}>{ConvertPriceToString(creditLimit.grantCredit)}</span></div>
                        </div>}
                        <PaymentWithValueModal
                            show={showMessageAskToPay}
                            onHide={handleAskToPayModal}
                            docNo={'Spłata limitu kredtowego'}
                            valueToPay={Math.max(0, creditLimit.grantCredit - creditLimit.remainCredit)}
                            creditLimit={creditLimit.remainCredit}
                        />
                        {isElavonActive && (
                            <button className='btn-app-secondary mt-3' onClick={() => setShowMessageAskToPay(true)} >
                                Spłać
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const ChangeCreditLimit = ({ handleEditLimit, handleChangeLimit }) => {
    return <>
        <div className="cont profile-details-info">
            <div className="row data-container mt-2">
                <div className="col">
                    <Form.Control type='number' name='newLimit' placeholder='Podaj wnioskowaną kwotę' onChange={handleEditLimit} autoFocus required />
                </div>
            </div>
            <div className="row data-container mt-4">
                <div className="col d-grid">
                    <button className='btn-app-primary' onClick={handleChangeLimit}>
                        Wnioskuj o zmianę
                    </button>
                </div>
                <div className='col d-grid'></div>
            </div>
        </div>
    </>
}

export default CreditLimitCard;